import React from 'react';
import decode from 'jwt-decode';
import { Client } from '@stomp/stompjs';
import EventReportsActions from '../redux/EventReportsRedux';
import WebSocketActions from '../redux/WebSocketRedux';
import { compose } from 'redux';
import { connect } from 'react-redux';
import Global from '../lib/Global';
import isEqual from 'lodash.isequal';
import cloneDeep from 'lodash.clonedeep';

const SOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL;
console.log('SOCKET_URL:', SOCKET_URL);
const queuePrefix = '/exchange/digioviui/';

class WebSocket extends React.Component {
  constructor() {
    super();
    this.state = {
      client: null,
    };
  }

  componentDidMount() {
    this.connectWebSocket();
  }

  componentWillUnmount() {
    this.state.client?.deactivate();
    this.props.clearSubscriptions();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!isEqual(prevProps.subscribeSites, this.props.subscribeSites)) {
      this.state.client ? this.manageSubscriptions(this.props.subscribeSites) : this.connectWebSocket();
    }
    if (!prevState.isError && this.state.isError) {
      console.log('An error occured with WebSocket. Reconnecting');
      if (!this.state.client) {
        this.connectWebSocket();
      }
    }
  }

  connectWebSocket() {
    console.log('connecting WebSocket');

    const onConnected = () => {
      console.log('WebSocket connected!');
      this.manageSubscriptions(this.props.subscribeSites);
    };
    const onDisconnected = () => {
      console.log('WebSocket disconnected!');
      this.props.clearSubscriptions();
    };
    const onError = (error) => {
      console.log('error:', error);
      this.setState({ isError: true });
    };
    const accessToken = Global.api.accessToken;

    if (accessToken && !this.state.client) {
      const client = new Client({
        connectHeaders: {
          login: accessToken,
          passcode: 'ui-client',
          host: 'digiovi',
        },
        brokerURL: SOCKET_URL,
        reconnectDelay: 5000,
        heartbeatIncoming: 30000,
        heartbeatOutgoing: 30000,
        onConnect: onConnected,
        onStompError: onError,
        onWebSocketError: onError,
        onDisconnect: onDisconnected,
        onWebSocketClose: onDisconnected,
      });

      client.debug = function(str) {
        // console.log(str);
      };

      client.activate();
      this.setState({ client });
    }
  }

  manageSubscriptions(siteIdsList) {
    if (!this.state.client) {
      this.setState({ isError: true });
      return;
    }
    const subscriptions = cloneDeep(this.props.subscriptions);
    console.log('subscriptions:', subscriptions)
    // convert sites list of siteIds to subs
    const newSites = siteIdsList.map((siteId) => ({ sub: decode(siteId)?.sub }));
    // Sites to subscribe: In normal case (first time): if the site is present in the newSites but was not in subscriptions. In case of error, subscribe again to all sites.
    const sitesToSubscribe = this.state.isError
      ? newSites
      : newSites.filter(({ sub }) => !subscriptions.find((subscription) => subscription.sub === sub));
    // Sites to unsubscribe: if the site was present in this.state.subscriptions but not anymore in the new siteIdsList
    const sitesToUnsubscribe = subscriptions.filter(({ sub }) => !newSites.find((site) => site.sub === sub));
    // reset subscriptions and set isError to false
    this.setState({ isError: false });
    const updatedSubscriptions = subscriptions.filter(({ sub }) => newSites.find((site) => site.sub === sub));
    //subscribe
    sitesToSubscribe.forEach(({ sub }) => {
      try {
        console.log('subscribing siteId sub:', sub);
        const queue = `${queuePrefix}events.${this.props.customerIdSub}.site.${sub}`;
        const subscription = this.state.client.subscribe(
          queue,
          (msg) => {
            try {
              const body = JSON.parse(msg.body);
              console.log('ws event body:', body);
              this.props.addWebSocketEvent({ ...body, receivedAt: Date.parse(new Date()) });
            } catch (error) {
              console.log('error:', error);
              this.setState({ isError: true });
            }
          },
          { id: `sub-${sub}` },
        );
        const isAlreadySubscribed = subscriptions.find((element) => element.sub === sub);
        // !isAlreadySubscribed && this.props.updateSubscriptions([...this.props.subscriptions, { subscription, sub }]);
        !isAlreadySubscribed && updatedSubscriptions.push({ subscription, sub });
      } catch (error) {
        console.log('error in subscribing site: ', sub);
        this.setState({ isError: true });
      }
    });
    //unsubscribe
    sitesToUnsubscribe.forEach(({ subscription, sub }) => {
      console.log('unsubscribing:', sub);
      subscription.unsubscribe();
    });
    // update subscriptions
    this.props.updateSubscriptions(updatedSubscriptions);
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    customerIdSub: state.auth.customerIdSub,
    webSocketEvents: state.eventReports.webSocketEvents,
    subscribeSites: state.webSocket.sites,
    subscriptions: state.webSocket.subscriptions,
  };
};

const mapDispatchToProps = (dispatch) => ({
  addWebSocketEvent: (singleEvent) => dispatch(EventReportsActions.addWebSocketEvent(singleEvent)),
  updateSubscriptions: (subscriptions) => dispatch(WebSocketActions.updateSubscriptions(subscriptions)),
  clearSubscriptions: () => dispatch(WebSocketActions.clearSubscriptions()),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(WebSocket);
